// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MxZM","footer":"styles_footer__1E5nk"};